import { Injectable } from '@angular/core';
import { ActiveMaintenanceNoticeDTO } from '@chicilon/angular-user-service';

@Injectable({ providedIn: 'root' })
export class MaintenanceStorageService {
  private readonly KEYS = {
    NOTICE_CACHE: 'chicilon_maintenance_notice_cache',
    DISMISSED_FLAG: 'chicilon_maintenance_dismissed'
  };

  getCachedNotice(): ActiveMaintenanceNoticeDTO | null {
    const raw = localStorage.getItem(this.KEYS.NOTICE_CACHE);

    if (!raw) return null;

    try {
      return JSON.parse(raw) as ActiveMaintenanceNoticeDTO;
    } catch {
      return null;
    }
  }

  setCachedNotice(notice: ActiveMaintenanceNoticeDTO): void {
    localStorage.setItem(this.KEYS.NOTICE_CACHE, JSON.stringify(notice));
  }

  clearCachedNotice(): void {
    localStorage.removeItem(this.KEYS.NOTICE_CACHE);
  }

  isDismissed(): boolean {
    return localStorage.getItem(this.KEYS.DISMISSED_FLAG) === 'true';
  }

  setDismissed(): void {
    localStorage.setItem(this.KEYS.DISMISSED_FLAG, 'true');
  }

  clearDismissed(): void {
    localStorage.removeItem(this.KEYS.DISMISSED_FLAG);
  }
}
